<template>
  <div class="creator-form">
    <b-row>
      <b-col>
        <b-form @submit.prevent="submitForm">
          <b-form-group>
            <div class="row mt-2 mb-3">
              <div class="col-sm-12 col-md-6">
                <b-form-input
                  v-model="form.name"
                  class="custom-form-input"
                  placeholder="Name*"
                  :state="validateState('name')"
                ></b-form-input>
              </div>
              <div class="col-sm-12 col-md-6 mt-3 mt-md-0">
                <b-form-input
                  v-model="form.email"
                  class="custom-form-input"
                  placeholder="Email address*"
                  :state="validateState('email')"
                ></b-form-input>
              </div>
              <div class="col-sm-12 col-md-6 mt-3">
                <b-form-input
                  v-model="form.phone"
                  class="custom-form-input"
                  placeholder="Mobile*"
                  :state="validateState('phone')"
                ></b-form-input>
              </div>
            </div>

            <div class="row mt-2 mb-3">
              <div class="col">
                <b-form-textarea
                  v-model="form.message"
                  class="custom-form-textarea"
                  placeholder="Message*"
                  rows="6"
                  max-rows="6"
                  :state="validateState('message')"
                ></b-form-textarea>
              </div>
            </div>

            <div class="row mt-2 mb-3">
              <div class="col-sm-12 col-md-6">
                <b-form-input
                  v-model="form.tiktok"
                  class="custom-form-input"
                  placeholder="TikTok"
                  :state="validateState('tiktok')"
                ></b-form-input>
              </div>
              <div class="col-sm-12 col-md-6 mt-3 mt-md-0">
                <b-form-input
                  v-model="form.instagram"
                  class="custom-form-input"
                  placeholder="Instagram"
                  :state="validateState('instagram')"
                ></b-form-input>
              </div>
              <div class="col-sm-12 col-md-6 mt-3">
                <b-form-input
                  v-model="form.youtube"
                  class="custom-form-input"
                  placeholder="YouTube"
                  :state="validateState('youtube')"
                ></b-form-input>
              </div>
            </div>

            <div class="row mt-2 mb-3">
              <div class="col-sm-12 col-md-6">
                <CustomSelector
                  v-model="form.isoCountry"
                  :options="countryOptions"
                  placeholder="Country*"
                  :state="validateState('isoCountry')"
                >
                </CustomSelector>
              </div>
            </div>

            <div class="row mt-2 mb-5">
              <div class="col">
                <p>
                  By submitting your contact details, you are providing your
                  data to Found.us who may contact you.
                </p>
              </div>
            </div>

            <div class="row mb-5 pb-3 justify-content-center">
              <div class="col-sm-12 col-md-6">
                <Button type="submit" full-width> Submit your details </Button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import map from 'lodash/map';

import Button from '../../components/Elements/Button';
import CustomSelector from '../../components/Elements/CustomSelector';

import countries from '@/misc/countries';
import { sendCreatorRequest } from '@/services/feedback';
import {
  phoneValidator,
  maxLength20,
  maxLength60,
  maxLengthValidator
} from '@/misc/validators';
import { sendReCaptchaToken } from '@/services/captcha';

const emptyForm = {
  name: null,
  email: null,
  phone: null,
  message: null,
  isoCountry: null,
  tiktok: null,
  instagram: null,
  youtube: null
};

export default {
  name: 'CreatorForm',

  components: {
    Button,
    CustomSelector
  },

  data() {
    return {
      form: {
        ...emptyForm
      }
    };
  },

  validations() {
    return {
      form: {
        name: { required, maxLength60 },
        email: { required, email },
        phone: { required, phoneValidator, maxLength20 },
        message: { required, maxLength6000: maxLengthValidator(6000) },
        isoCountry: { required },
        tiktok: { maxLength60 },
        instagram: { maxLength60 },
        youtube: { maxLength60 }
      }
    };
  },

  computed: {
    countryOptions() {
      return map(countries, (value, key) => ({ value: key, text: value }));
    }
  },

  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    handleChange(event) {
      this.form.reason = event;
    },
    checkFormValidation() {
      this.$v.form.$touch();
      return !this.$v.form.$anyError;
    },
    async submitForm() {
      if (!this.checkFormValidation()) {
        this.$nextTick(() => {
          document.getElementsByClassName('is-invalid')[0]?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        });
        return;
      }

      const token = await this.$recaptcha.execute('submit');
      const recaptcha = await sendReCaptchaToken(token);

      if (recaptcha.success) {
        sendCreatorRequest(this.form)
          .then(() => {
            this.form = { ...emptyForm };
            this.$v.form.$reset();
            this.$showToastMessage(
              'Your message has been sent. You will be contacted shortly',
              'Success',
              'success'
            );
          })
          .catch(() => {
            this.$showToastMessage(
              'Sorry, something went wrong',
              'Error',
              'danger'
            );
          });
      } else {
        this.$showToastMessage('Captcha error', 'Error', 'danger');
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../styles/components';

.creator-form {
  .custom-selector__dropdown {
    .active-list {
      background: $dark-color !important;
      color: $white-color !important;
      border: 1px solid $grey-color !important;

      img {
        filter: none;
      }
    }
  }
}
</style>
